// The details of the service provider (BL-133, docs/Вопросы.md п. 6): one source for the footer, the /subscribe summary
// and the legal pages. Since ADR-0058 (Stripe Managed Payments) VALAS is the provider of the service - Terms, support,
// data - and Stripe is the merchant of record that sells the subscription, collects the tax and issues the receipts and
// invoices (PAYMENT_PROCESSOR); subscriptions started before that keep VALAS as the seller. Terms (legal/terms-paid.html,
// public/terms.html), Refunds and Privacy are static files that repeat these values by hand - web/test/seller.test.ts
// keeps them equal. They are not kept in the database.
export const SELLER = {
  legalName: "VALAS OÜ – PODRUŽNICA V SLOVENIJI",
  tradeName: "Valas Team",
  street: "Mlinska ulica 22",
  postalCode: "2000",
  city: "Maribor",
  country: "Slovenia",
  vatId: "SI57438285",
  email: "connect@valas.team",
  site: "https://marketing-kit.app",
} as const;

/** «Mlinska ulica 22, 2000 Maribor, Slovenia» - as in Terms §1. */
export const SELLER_ADDRESS = `${SELLER.street}, ${SELLER.postalCode} ${SELLER.city}, ${SELLER.country}`;

/** Who sells the subscription (ADR-0058): Stripe as merchant of record. No legal entity is named - Stripe's receipt does. */
export const PAYMENT_PROCESSOR = { name: "Stripe", role: "merchant of record", url: "https://stripe.com" } as const;
